module.exports = __webpack_public_path__ + "img/horizontal_3_6_r_pp13_0.d6c36a49.png";